import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-flex flex-wrap justify-content-between align-items-center py-3 pb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "m-3 text-muted" }, "© 2022 Super Power Company, Inc")
], -1)
const _hoisted_5 = { class: "nav col-md-4 justify-content-end list-unstyled d-flex icons m-3" }
const _hoisted_6 = { class: "ms-3" }
const _hoisted_7 = {
  class: "text-muted",
  href: "#"
}
const _hoisted_8 = { class: "ms-3" }
const _hoisted_9 = {
  class: "text-muted",
  href: "#"
}
const _hoisted_10 = { class: "ms-3" }
const _hoisted_11 = {
  class: "text-muted",
  href: "#"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("footer", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-instagram" })
            ])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("a", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-line" })
            ])
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("a", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-facebook" })
            ])
          ])
        ])
      ])
    ])
  ]))
}